export default "/assets/images/hepa.png?5ceb7736d6abea6f0db5c9f17381e6e7";